import React from "react";
import "./FlashcardPage.css";
import Flashcard from "../components/Flashcard";

const FlashcardPage = () => {
    return (
        <div className="main-container">
            <Flashcard />
        </div>
    );
}

export default FlashcardPage;